import React, { useState, useEffect } from 'react'
import { IMAGE } from '../constent/theme'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay, EffectFade, Navigation, Pagination } from 'swiper/modules'
import { Link } from 'react-router-dom';
import { vehicleApi } from '../services/api';

const Homeslide = () => {
    const swiperRef = React.useRef(null)
    const [sliderVehicles, setSliderVehicles] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        vehicleApi.getAll({ per_page: 3, sort_by: 'created_at', sort_direction: 'desc' })
            .then(res => {
                if (res.data && res.data.data) {
                    setSliderVehicles(res.data.data);
                }
            })
            .catch(err => console.error('Failed to load slider vehicles:', err))
            .finally(() => setLoading(false));
    }, []);

    // Show a dark skeleton while the API is loading — no fake cars ever shown
    if (loading) {
        return (
            <div className="col-lg-6">
                <div className="banner-slider" style={{ background: '#111', position: 'relative', minHeight: '500px', display: 'flex', alignItems: 'flex-end', padding: '40px' }}>
                    <div>
                        <div style={{ width: '120px', height: '14px', background: '#333', borderRadius: '4px', marginBottom: '12px' }}></div>
                        <div style={{ width: '260px', height: '30px', background: '#333', borderRadius: '4px', marginBottom: '20px' }}></div>
                        <div style={{ width: '80px', height: '14px', background: '#333', borderRadius: '4px' }}></div>
                    </div>
                </div>
            </div>
        );
    }

    // Nothing in DB yet — show empty space (better than fake Porsche!)
    if (sliderVehicles.length === 0) {
        return <div className="col-lg-6"></div>;
    }

    const displaySlides = sliderVehicles.map((vehicle, index) => ({
        id: vehicle.id,
        imag1: vehicle.images && vehicle.images[0]
            ? vehicle.images[0].url
            : (index === 0 ? IMAGE.slide_pic1 : (index === 1 ? IMAGE.slide_pic2 : IMAGE.slide_pic3)),
        car_type: vehicle.category_name ? vehicle.category_name.toUpperCase() : 'VÉHICULE',
        name: `${vehicle.manufacturer_name} ${vehicle.model}`,
        price: `€ ${vehicle.gross_price ? vehicle.gross_price.toLocaleString() : 'Sur demande'}`,
        link: `/car-details/${vehicle.id}`
    }));

    return (
        <div className="col-lg-6">
            <div className="banner-slider">
                <Swiper className="swiper-container main-silder-swiper"
                    spaceBetween={30}
                    effect={"fade"}
                    speed={1500}
                    modules={[EffectFade, Navigation, Pagination, Autoplay]}
                    autoplay={{ delay: 3500 }}
                    loop={true}
                    ref={swiperRef}
                >
                    {displaySlides.map((slide, index) => (
                        <SwiperSlide className="swiper-slide" key={slide.id || index}>
                            <div className="dlab-slide-item">
                                <div className="silder-content">
                                    <div className="inner-content">
                                        <div className="left">
                                            <p className="car-type">{slide.car_type}</p>
                                            <p className="car-name slide-vertical" data-splitting>{slide.name}</p>
                                        </div>
                                        <div className="right">
                                            <p className="price-label">À partir de </p>
                                            <p className="car-price" data-splitting>{slide.price}</p>
                                        </div>
                                    </div>
                                    <Link to={slide.link} data-splitting className="discover-link">DÉCOUVRIR</Link>
                                </div>
                                <div className="slider-img">
                                    <img
                                        src={slide.imag1}
                                        alt={slide.name}
                                        onError={(e) => { e.target.onerror = null; e.target.src = IMAGE.slide_pic1; }}
                                    />
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}

                    <div className="slider-one-pagination">
                        <div className="btn-prev swiper-button-prev1 cursorPointer"
                            onClick={() => swiperRef.current?.swiper?.slidePrev()}
                        ><i className="fas fa-chevron-left"></i></div>
                        <div className="btn-next swiper-button-next1 cursorPointer"
                            onClick={() => swiperRef.current?.swiper?.slideNext()}
                        ><i className="fas fa-chevron-right"></i></div>
                    </div>
                </Swiper>
            </div>
        </div>
    )
}

export default Homeslide